import styledNormalize from 'styled-normalize';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  ${styledNormalize}

  * {
    box-sizing: border-box;
  }

  body {
    padding: 0;
    margin: 0;
    line-height: 1.4;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
  }
`;
